import { createContext, useContext } from 'react';

export const RefreshContext = createContext(30_000);

export function useRefreshInterval() {
  return useContext(RefreshContext);
}
